/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('popup.pdf', ['popup']);